class ResourceLookupValue{
    private  _LookupName:string="";
    
    public get LookupName() : string {return this._LookupName}   
    public set LookupName(newvalue: string)  {this._LookupName=newvalue} 

    //ValueField_Name
    private  _ValueField_Name:string="";

    public get ValueField_Name() : string {return this._ValueField_Name}
    public set ValueField_Name(newvalue: string)  {this._ValueField_Name=newvalue}

    //ValueField_Name_Alias
    private  _ValueField_Name_Alias:string="";
    public get ValueField_Name_Alias() : string {return this._ValueField_Name_Alias}
    public set ValueField_Name_Alias(newvalue: string)  {this._ValueField_Name_Alias=newvalue}

}

export default ResourceLookupValue;